import React from 'react'

class SignupForm extends React.Component {

  componentDidMount() {
    const { formRefs, formError } = this.props

    // Helper function to check if form element is valid
    const forceFormCheck = (i) => {
      const element = i.currentTarget

      if( !element.checkValidity() ) {
        element.classList.add("error")
        formError(true)
      } else {
        element.classList.remove("error")
        formError(false)
      }
    }

    // Add form validation check
    Object.keys(formRefs).forEach(i => formRefs[i].addEventListener("blur", forceFormCheck))

    // Prepend the URL with http:// on focus when field is empty
    formRefs.url.addEventListener("focus", (i) => {
      const element = i.currentTarget
      if( element.value.length < 1 ) {
        element.value = "https://"
      }
    })

    // Focus the first field on load
    formRefs.email.focus()
  }

  render() {
    const { requireConsent, consentError, formEnabled, formRefs, handleSubmit, handleFormChange } = this.props

    const consentColor = consentError ? 'var(--primary-red-color)' : 'var(--primary-grey-color)'
    const privacyLinkColor = consentError ? 'var(--primary-grey-color)' : 'var(--primary-green-color)'

    return (
      <div className="form-container">
        <form>
          <input type="email" placeholder="Email address" autoComplete="nope" ref={i => formRefs.email = i} onChange={handleFormChange}/>
          <input type="url" placeholder="Your website URL" autoComplete="nope" ref={i => formRefs.url = i} onChange={handleFormChange}/>
          <input type="text" placeholder="Full name" autoComplete="nope" ref={i => formRefs.name = i} onChange={handleFormChange}/>
          <input type="tel" placeholder="Phone number" autoComplete="nope" ref={i => formRefs.phone = i} onChange={handleFormChange}/>
          <select ref={i => formRefs.budget = i} onChange={handleFormChange}>
            <option defaultValue>Monthly marketing budget</option>
            <option>$0 to $500</option>
            <option>$500 to $2500</option>
            <option>$2500 to $5000</option>
            <option>$5000 to $10000</option>
            <option>$10000 to $25000</option>
            <option>$25000 plus</option>
          </select>
          {
            requireConsent &&
            <div style={{color: consentColor, fontSize: '0.8em', lineHeight: '1.2'}}>
              <input type="checkbox" ref={i => formRefs.consent = i} onChange={handleFormChange} />
              I agree to the <a href="/privacy" target="_blank" style={{color: privacyLinkColor}}>Privacy Policy</a> and understand I may periodically receive email related to my website.
            </div>
          }

          <button onClick={handleSubmit} disabled={!formEnabled}>Grow my traffic</button>
        </form>
      </div>
    )
  }
}

export default SignupForm



// WEBPACK FOOTER //
// ./src/components/homepage/signup_form.js